import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { CerUiIcons } from '@ui/cer-ui-icons';
import { ExchangeMsgClient } from 'src/app/api';

const uiCmdReprocessJobLog: UiCommand = { id: 'ReprocessJobLog', text: 'Kør markeret igen', iconCss: CerUiIcons.import, tooltipText: 'Indlæs data igen for markeret post', target: ".e-content", needSelection: true };

export class DataJobLogForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      mandatory: true,
      viewMetadata: {
        dataApiName: 'DataJobLog',
        name: 'job-log', text: 'Datajob log',
        allowCreate: false, allowEdit: false, allowDelete: false,
        primaryKey: 'id', 
        baseFields: ['id'],
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'DataJobTaskLog', parentColumn: 'jobLogId', column: 'id'}}
        ]
      },
      fieldMetadata: [
        { name: 'jobId', text: 'Job log', foreignKeyTableName: 'DataJob', foreignKeyField: 'id', foreignKeyValue: 'name'  },
        { name: 'sourceAddress', text: 'Navn'},
        { name: 'pickedUp', text: 'Hentet', format: 'Number0' },
        { name: 'processed', text: 'Behandlet', format: 'Number0' },
        { name: 'completed', text: 'Indlæst', format: 'Number0' },
        { name: 'failed', text: 'Fejlet', format: 'Number0' },
        { name: 'ignored', text: 'Ignoreret', format: 'Number0' },
        { name: 'copied', text: 'Kopieret', format: 'Number0' },
        { name: 'durationSeconds', text: 'Tid (sek)', format: 'Number0' },
        { name: 'partial', text: 'Delvis', format: 'CheckBox' },
        { name: 'created', text: 'Oprettet', format: 'DateTime', orderBy: 'Descending', width: '120px' },
        { name: 'modified', text: 'Ændret', format: 'DateTime', visible: false, width: '120px' }
      ],
      contextMenuCommands: [uiCmdReprocessJobLog],
      onCommandEvent: (e => this.onCommand(e)),
    });

  }

  // Commands
  public onCommand(event: UiCommandEvent) {
    switch (event.commandId) {
      case uiCmdReprocessJobLog.id:
        if (event.rowData?.id != null) {
          this.reprocessJobLog(event.rowData?.id);
        }
        break;
    }
  }

  private reprocessJobLog(jobLogId: number) {
    const client: ExchangeMsgClient = this.context.injector.get(ExchangeMsgClient);
    this.context.ui.operationBegin(`Genbehandler data`);
    client.reprocessJobLog(jobLogId).subscribe({
      next: (ok) => this.context.ui.operationEnd("Fuldført"),
      error: (error) => this.context.ui.operationEndError(error)
    });
  }
}
